import React, { useContext, useEffect, useState, useCallback } from "react";
import SocketContext from "../../../../../context/SocketContext";
import { useDispatch } from "react-redux";
const fmt = require("indian-number-format");

export default function ProfitLoss({ item, symbol_id, total, userType }) {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);
  const [pf, setPf] = useState(0);

  // ✅ Calculate Profit/Loss (with dollar_rate for specific types)
  const calculatePL = useCallback(
    (data) => {
      if (!data || !item) return 0;

      const bid = parseFloat(data.Bid) || 0;
      const ask = parseFloat(data.Ask) || 0;
      const ltp = parseFloat(data.LTP) || 0;
      const rate = parseFloat(item.rate) || 0;
      const qty = parseFloat(item.qty) || 0;
      const dollarRate = parseFloat(item.dollar_rate) || 1;
      const rupee_dollar = parseFloat(item.rupee_dollar);

      let profit = 0;

      if (item.buy_sell === 0) {
        // 🟢 Buy position
        const sellPrice = bid > 0 ? bid : ltp;
        profit = (sellPrice - rate) * qty;
      } else {
        // 🔴 Sell position
        const buyPrice = ask > 0 ? ask : ltp;
        profit = (rate - buyPrice) * qty;
      }

      // ✅ Apply dollar_rate for specific types
      if (rupee_dollar === 0) {
        if (
          item.type === "comex_future" ||
          item.type === "crypto_future" ||
          item.type === "forex_future" ||
          item.type === "us_stock" ||
          item.type === "index" ||
          item.type === "dgcx"
        ) {
          profit *= dollarRate;
        }
      }

      return profit;
    },
    [item],
  );

  // ✅ Socket event handling
  useEffect(() => {
    if (!socket || !symbol_id) return;

    const eventName = "trade" + symbol_id;

    const handleTrade = (data) => {
      const pl = calculatePL(data);
      setPf(parseFloat(pl).toFixed(2));
    };

    socket.emit("giverate", symbol_id);
    socket.on(eventName, handleTrade);

    return () => {
      socket.off(eventName, handleTrade);
    };
  }, [socket, symbol_id, calculatePL]);

  // ✅ Derived values
  const admin_pf = (
    (parseFloat(pf) * parseFloat(item.admin_sharing || 0)) /
    100
  ).toFixed(2);

  // ✅ Dispatch updates
  useEffect(() => {
    if (!item?.id) return;

    dispatch({
      type: "PF",
      symbol_id: item.id,
      admin_pf,
      pf,
      total,
    });
  }, [dispatch, item?.id, admin_pf, pf, total]);

  return (
    <>
      {/* ✅ User PF */}
      <div className="menuBuyQty">
        <div className={`menuBuyPrice ${pf >= 0 ? "buytext" : "selltext"}`}>
          {fmt.format(pf)}
        </div>
      </div>

      {/* ✅ Admin PF (for specific user types) */}
      {(userType === 1 ||
        userType === 2 ||
        userType === 3 ||
        userType === 5) && (
        <div className="menuBuyQty">
          <div
            className={`menuBuyPrice ${admin_pf <= 0 ? "buytext" : "selltext"}`}
          >
            {fmt.format(Math.abs(admin_pf))}
          </div>
        </div>
      )}
    </>
  );
}
